interface PixelProps {
  code: string;
}

const GSCVerification = ({ code }: PixelProps) => {
  return code ? <meta name="google-site-verification" content={code} /> : null;
};

export default GSCVerification;
